import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Continuously remove the injected "Made with Emergent" badge.
// CSS alone can't fully kill it (its inline !important styles beat external CSS).
function killEmergentBadge() {
  document.querySelectorAll('#emergent-badge').forEach((n) => n.remove());
}
killEmergentBadge();
if (typeof MutationObserver !== 'undefined') {
  new MutationObserver(killEmergentBadge).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
